import { type ColumnDef } from '@tanstack/react-table';

import { formatarData } from '@/lib/formato';
import { Carimbo, type TomCarimbo } from '@/ui/components/carimbo';
import { ChaveAcesso } from '@/ui/components/chave-acesso';
import { Dinheiro } from '@/ui/components/dinheiro';
import { DocumentoTexto } from '@/ui/components/documento-texto';
import { type MetaColuna } from '@/ui/components/tabela-dados';
import { type ChavePendente } from '@fiscoai/contracts';

/** A situação vem como texto do relatório da SEFAZ ("Autorizada", "Cancelada"...). */
function tomSituacao(situacao: string): TomCarimbo {
  const s = situacao.toLowerCase();
  if (s.startsWith('autoriz')) return 'sucesso';
  if (s.startsWith('cancel')) return 'perigo';
  if (s.startsWith('deneg')) return 'alerta';
  return 'neutro';
}

const meta = (m: MetaColuna) => m;

export const colunasChaves: ColumnDef<ChavePendente>[] = [
  {
    id: 'emissao',
    header: 'Emissão',
    meta: meta({ largura: '7rem' }),
    cell: ({ row }) => (
      <span className="tabular text-texto-suave">{formatarData(row.original.emitidaEm)}</span>
    ),
  },
  {
    id: 'numero',
    header: 'Nota',
    meta: meta({ largura: '6rem' }),
    cell: ({ row }) => <span className="tabular font-medium">{Number(row.original.numero)}</span>,
  },
  {
    id: 'emitente',
    header: 'Emitente',
    cell: ({ row }) => (
      <span className="grid min-w-0 leading-tight">
        <span className="truncate font-medium">
          {row.original.emitenteNome ?? 'Nome não informado'}
        </span>
        <DocumentoTexto
          valor={row.original.emitenteDocumento}
          className="text-xs text-texto-fraco"
        />
      </span>
    ),
  },
  {
    id: 'situacao',
    header: 'Na SEFAZ',
    meta: meta({ largura: '8.5rem' }),
    cell: ({ row }) =>
      row.original.situacaoSefaz ? (
        <Carimbo tom={tomSituacao(row.original.situacaoSefaz)}>
          {row.original.situacaoSefaz}
        </Carimbo>
      ) : (
        <span className="text-texto-fraco">—</span>
      ),
  },
  {
    id: 'chave',
    header: 'Chave de acesso',
    cell: ({ row }) => <ChaveAcesso chave={row.original.chave} compacta />,
  },
  {
    id: 'valor',
    header: 'Valor',
    meta: meta({ alinhar: 'direita', largura: '9rem' }),
    cell: ({ row }) => <Dinheiro valor={row.original.valorTotal} className="font-medium" />,
  },
];
